import { render } from "./PartInfo.vue?vue&type=template&id=13215850&scoped=true"
import script from "./PartInfo.vue?vue&type=script&lang=js"
export * from "./PartInfo.vue?vue&type=script&lang=js"

import "./PartInfo.vue?vue&type=style&index=0&id=13215850&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13215850"]])

export default __exports__